import { render, staticRenderFns } from "./CouponDiscountProductsTable.vue?vue&type=template&id=c9357a3a&scoped=true"
import script from "./CouponDiscountProductsTable.vue?vue&type=script&lang=js"
export * from "./CouponDiscountProductsTable.vue?vue&type=script&lang=js"
import style0 from "./CouponDiscountProductsTable.vue?vue&type=style&index=0&id=c9357a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9357a3a",
  null
  
)

export default component.exports